const permissions = require('./constants').permissionIds;
const features = require('./constants').featureIds;

const strings = {
    permissionDescriptions: {
        [permissions.aPlusTeacherApp]: 'Login to Alert+ phone app',
        [permissions.orchestrateEdit]: 'Manage Orchestrate',
        [permissions.cmsEdit]: 'Add and delete CMSes from cloud',
        [permissions.userEdit]: 'Add, create, edit other users as well as add, create, edit, and assign roles',
        [permissions.aPlusEdit]: 'Assign other users to sites',
        [permissions.licensesEdit]: 'Activate and deactivate licenses',
        [permissions.hwWarrantyRead]: 'View HW Warranty state of receivers',
        [permissions.msgManagerEdit]: 'Edit Users, Edit Group, View Logs',
        [permissions.msgManagerFrontDeskView]: 'Create and Clear Message, Edit Scheduled Messages, View Status',
    },
    featureNames: {
        [features.aPlus]: 'AlertPlus',
        [features.licenseManagement]: 'License Management',
        [features.orchestrate]: 'Orchestrate',
        [features.hwWarranty]: 'Hardware Warranty',
        [features.msgManager]: 'Message Manager',
    }
}

export default strings;